// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CircleFilledSvg from "@fishx/icons-svg/es/asn/CircleFilled";
import FishxIcon from '../components/FishxIcon';

var CircleFilled = function CircleFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CircleFilledSvg
  }));
};

CircleFilled.displayName = 'CircleFilled';
export default React.forwardRef(CircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CircleFilled.js
// module id = 2222
// module chunks = 0